(function () {
  'use strict';
  /* May be included by the collection AND the homepage product slider
     (for Quick Add). Run once, whatever loaded first. */
  if (window.__baeCollectionJS) return;
  window.__baeCollectionJS = true;

  const root = document.querySelector('[data-bae-collection]');

  /* Larger colour swatches on collection cards, so a second colour is noticed. */
  if (root) {
    const st = document.createElement('style');
    st.textContent = '.bae-coll .bae-card__swatches{gap:9px;margin-top:8px}' +
      '.bae-coll .bae-card__swatches .bae-swatch{width:24px;height:24px}' +
      '.bae-coll .bae-card__swatches .bae-card__more{font-size:12px;letter-spacing:.06em;margin-left:4px}';
    document.head.appendChild(st);
  }

  /* ---------- Quick Add (global: collection grid + homepage slider) ---------- */
  let modal = null;
  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'bae-qa';
    modal.innerHTML =
      '<div class="bae-qa__scrim" data-close></div>' +
      '<div class="bae-qa__panel" role="dialog" aria-modal="true">' +
      '<button class="bae-qa__close" type="button" aria-label="Sluiten" data-close>&times;</button>' +
      '<div data-body></div></div>';
    document.body.appendChild(modal);
    modal.addEventListener('click', (e) => { if (e.target.hasAttribute('data-close')) closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeModal(); });
    return modal;
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bae-quickadd]');
    if (!btn) return;
    e.preventDefault();
    const m = ensureModal();
    const body = m.querySelector('[data-body]');
    body.innerHTML = '<p class="bae-qa__price">Laden…</p>';
    m.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    fetch('/products/' + btn.dataset.baeQuickadd + '.js')
      .then((r) => r.json()).then((p) => renderQuickAdd(body, p))
      .catch(() => { body.innerHTML = '<p class="bae-qa__msg">Kon dit product niet laden.</p>'; });
  });

  function renderQuickAdd(body, p) {
    const money = (c) => (c / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
    const names = p.options.map((o) => (o.name || o));
    const sizeIdx = names.findIndex((n) => /size|maat/i.test(n));
    const colourIdx = names.findIndex((n) => /colou?r|kleur/i.test(n));
    const first = p.variants[0];
    const colour = colourIdx > -1 && first ? first.options[colourIdx] : '';
    const variants = colour ? p.variants.filter((v) => v.options[colourIdx] === colour) : p.variants;

    body.innerHTML =
      '<div class="bae-qa__row">' +
      (p.featured_image ? '<img class="bae-qa__img" src="' + p.featured_image + '&width=300" alt="">' : '') +
      '<div><h3 class="bae-qa__name">' + p.title + '</h3>' +
      '<p class="bae-qa__price">' + money(p.price) + '</p>' +
      (colour ? '<p class="bae-qa__colour">' + colour + '</p>' : '') +
      '</div></div>' +
      '<span class="bae-kicker bae-qa__label">' + (sizeIdx > -1 ? 'Maat' : 'Kies') + '</span>' +
      '<div class="bae-qa__sizes">' +
      variants.map((v) => '<button class="bae-qa__size" type="button" data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        (sizeIdx > -1 ? v.options[sizeIdx] : v.title) + '</button>').join('') +
      '</div>' +
      '<button class="bae-btn bae-btn--primary bae-btn--block bae-qa__cta" type="button" disabled data-add>Kies een maat</button>' +
      '<p class="bae-qa__msg" data-msg></p>' +
      '<p style="margin-top:14px"><a class="bae-link" href="' + p.url + '">Bekijk product</a></p>';

    let selected = null;
    const cta = body.querySelector('[data-add]');
    const msg = body.querySelector('[data-msg]');

    /* Single-variant products (one-size caps, socks) need no size step:
       the only variant is pre-selected and the CTA is ready immediately.
       Without a real size option (Shopify's default "Title" variant) the
       size row is not shown at all. */
    if (variants.length === 1) {
      const only = body.querySelector('.bae-qa__size');
      if (only) only.classList.add('is-active');
      selected = String(variants[0].id);
      cta.disabled = false;
      cta.textContent = 'In winkelmand';
      if (sizeIdx === -1) {
        body.querySelector('.bae-qa__label').hidden = true;
        body.querySelector('.bae-qa__sizes').hidden = true;
      }
    }

    body.querySelectorAll('.bae-qa__size').forEach((b) => {
      b.addEventListener('click', () => {
        body.querySelectorAll('.bae-qa__size').forEach((x) => x.classList.remove('is-active'));
        b.classList.add('is-active');
        selected = b.dataset.vid;
        cta.disabled = false;
        cta.textContent = 'In winkelmand';
      });
    });

    cta.addEventListener('click', () => {
      if (!selected) return;
      cta.disabled = true;
      cta.textContent = 'Toevoegen…';
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(selected), quantity: 1 }] })
      })
        .then((r) => r.json()).then(() => fetch('/cart.js')).then((r) => r.json())
        .then((cart) => {
          document.dispatchEvent(new CustomEvent('bae:cart:updated', { detail: cart }));
          cta.textContent = 'Toegevoegd';
          setTimeout(closeModal, 550);
        })
        .catch(() => {
          msg.textContent = 'Er ging iets mis. Probeer opnieuw.';
          cta.disabled = false;
          cta.textContent = 'In winkelmand';
        });
    });
  }

  /* ---------- Card media (global: works on collection, PDP recs, search) ---------- */
  const cardTrack = (card) => card.querySelector('[data-bae-card-track]');

  /* signature slide bar on each card */
  function syncBar(card) {
    const track = cardTrack(card);
    const thumb = card.querySelector('[data-bae-card-thumb]');
    if (!track || !thumb) return;
    const count = track.children.length || 1;
    const w = 100 / count;
    const i = Math.round(track.scrollLeft / track.clientWidth);
    thumb.style.width = w + '%';
    thumb.style.left = (i * w) + '%';
  }
  function syncAllBars() {
    document.querySelectorAll('[data-bae-card]').forEach(syncBar);
  }

  document.addEventListener('scroll', (e) => {
    const track = e.target.closest ? e.target.closest('[data-bae-card-track]') : null;
    if (track) syncBar(track.closest('[data-bae-card]'));
  }, true);
  window.addEventListener('resize', syncAllBars);

  document.addEventListener('click', (e) => {
    const next = e.target.closest('[data-bae-card-next]');
    const prev = e.target.closest('[data-bae-card-prev]');
    if (next || prev) {
      e.preventDefault();
      const track = cardTrack((next || prev).closest('[data-bae-card]'));
      if (track) track.scrollBy({ left: (next ? 1 : -1) * track.clientWidth, behavior: 'smooth' });
      return;
    }

    const sw = e.target.closest('[data-bae-swatch]');
    if (sw) {
      e.preventDefault();
      const card = sw.closest('[data-bae-card]');
      card.querySelectorAll('[data-bae-swatch]').forEach((s) => s.classList.remove('is-active'));
      sw.classList.add('is-active');

      /* Fit-aware: with Box or Oversized active, the swatch shows that fit's
         photo and links to that fit's variant. */
      const fm = card.dataset.fitMode;
      const k = fm === 'box' ? 'Box' : fm === 'oversized' ? 'Over' : '';
      const img = (k && sw.dataset['img' + k]) || sw.dataset.img;
      const first = card.querySelector('.bae-card__slide img');
      if (img && first) { first.src = img; first.removeAttribute('srcset'); }

      const label = card.querySelector('[data-bae-card-colour]');
      if (label && sw.dataset.colour) label.textContent = sw.dataset.colour;

      const url = (k && sw.dataset['url' + k]) || sw.dataset.variantUrl;
      if (url) card.querySelectorAll('a.bae-card__link, a.bae-card__name').forEach((a) => (a.href = url));
    }
  });

  if (!root) { syncAllBars(); return; }

  /* ---------- fit + view + colour ---------- */
  let currentFit = 'all';
  let currentView = 'flat';
  /* Colour shown on every card that offers it (Vintage Black / Vintage White,
     Black / Beige). 'all' = every card keeps its own first colour. */
  let currentColour = 'all';
  /* True while the remaining pagination pages are pulled in so a fit selection
     can be judged against the whole collection instead of the first page. */
  let completing = false;

  /* Looked up live: a sort/filter re-render replaces the markup inside
     [data-bae-collection], so cached element references go stale. */
  const fitButtons = () => root.querySelectorAll('[data-bae-fit]');
  const viewButtons = () => root.querySelectorAll('[data-bae-view]');
  const colourButtons = () => root.querySelectorAll('[data-bae-colour]');

  /* Editorial moments. The tiles are rendered once by Liquid at the end of the
     grid and are MOVED here (never cloned), so filtering, sorting and infinite
     loading can never produce a duplicate or a tile stranded between hidden
     product nodes. Tile n sits directly behind the (n * 4)th visible product. */
  function placeCampaigns(shown) {
    const grid = root.querySelector('[data-bae-grid]');
    if (!grid) return;
    [1, 2].forEach((n) => {
      const tile = root.querySelector('[data-bae-campaign="' + n + '"]');
      if (!tile) return;
      const at = n * 4;
      if (shown.length <= at) { tile.hidden = true; return; }
      const ref = shown[at];
      if (tile.parentNode !== grid || tile.nextElementSibling !== ref) grid.insertBefore(tile, ref);
      tile.hidden = false;
    });
  }

  /* A card may belong to more than one fit (data-fit="oversized box"): every
     whitespace-separated token is normalised on its own. */
  const cardFitList = (card) => (card.dataset.fit || '').trim().split(/\s+/).map(normFit).filter((f) => f && f !== 'all');

  function apply() {
    let visible = 0;
    const shown = [];
    root.querySelectorAll('[data-bae-card]').forEach((card) => {
      const fitsOfCard = cardFitList(card);
      const show = currentFit === 'all' || fitsOfCard.indexOf(currentFit) > -1;
      card.style.display = show ? '' : 'none';
      if (!show) return;
      visible += 1;
      shown.push(card);
      card.dataset.fitMode = currentFit;

      /* Colour swatches that do not exist in the active fit are hidden
         (Stone Grey / Vanilla Cream only exist as Box). If the active swatch
         is one of them, the first remaining colour becomes active. */
      const sws = Array.from(card.querySelectorAll('[data-bae-swatch]'));
      let activeSw = null;
      const setLabel = (sw) => {
        const lab = card.querySelector('[data-bae-card-colour]');
        if (lab && sw && sw.dataset.colour) lab.textContent = sw.dataset.colour;
      };
      if (sws.length) {
        sws.forEach((s) => {
          const f = (s.dataset.fits || '').split(/\s+/).filter(Boolean);
          const ok = currentFit === 'all' || !f.length || f.indexOf(currentFit) > -1;
          s.style.display = ok ? '' : 'none';
          s.dataset.hiddenFit = ok ? '' : '1';
        });
        activeSw = sws.find((s) => s.classList.contains('is-active') && !s.dataset.hiddenFit) || null;
        if (!activeSw) {
          activeSw = sws.find((s) => !s.dataset.hiddenFit) || null;
          sws.forEach((s) => s.classList.remove('is-active'));
          if (activeSw) { activeSw.classList.add('is-active'); setLabel(activeSw); }
        }

        /* Collection-wide colour choice: cards that offer the colour switch to
           it; going back to "Alle kleuren" returns them to their first colour. */
        if (currentColour !== 'all') {
          const m = sws.find((s) => s.dataset.colour === currentColour && !s.dataset.hiddenFit);
          if (m && m !== activeSw) {
            sws.forEach((s) => s.classList.remove('is-active'));
            m.classList.add('is-active');
            activeSw = m;
            setLabel(m);
          }
        } else if (card.dataset.colourMode && card.dataset.colourMode !== 'all') {
          const f0 = sws.find((s) => !s.dataset.hiddenFit) || null;
          if (f0 && f0 !== activeSw) {
            sws.forEach((s) => s.classList.remove('is-active'));
            f0.classList.add('is-active');
            activeSw = f0;
            setLabel(f0);
          }
        }
        card.dataset.colourMode = currentColour;
      }

      /* A card in BOTH fits follows the active fit filter: Box fit shows the
         Box photo and links to the Box variant, Oversized links to the
         Oversized variant, Alle fits keeps the default. */
      const both = fitsOfCard.length > 1;
      let flatSrc = card.dataset.flatSrc;
      let linkUrl = card.dataset.baseUrl || '';
      if (both && currentFit === 'box') {
        if (card.dataset.boxSrc) flatSrc = card.dataset.boxSrc;
        if (card.dataset.boxUrl) linkUrl = card.dataset.boxUrl;
      } else if (both && currentFit === 'oversized') {
        if (card.dataset.overUrl) linkUrl = card.dataset.overUrl;
      }

      /* A non-default colour stays selected across fit changes: use that
         colour's photo and variant for the active fit. */
      const swIdx = activeSw ? sws.indexOf(activeSw) : 0;
      if (swIdx > 0 && activeSw) {
        const k = both ? (currentFit === 'box' ? 'Box' : currentFit === 'oversized' ? 'Over' : '') : '';
        const si = (k && activeSw.dataset['img' + k]) || activeSw.dataset.img;
        const su = (k && activeSw.dataset['url' + k]) || activeSw.dataset.variantUrl;
        if (si) flatSrc = si;
        if (su) linkUrl = su;
      }
      if (linkUrl && (both || sws.length)) card.querySelectorAll('a.bae-card__link, a.bae-card__name').forEach((a) => (a.href = linkUrl));

      /* Deterministic media per mode; reset the card slider to the first
         slide so the switch is always visible, whatever was swiped. */
      const src = currentView === 'model' ? card.dataset.modelSrc : flatSrc;
      const img = card.querySelector('.bae-card__slide img');
      if (src && img && img.getAttribute('src') !== src) { img.src = src; img.removeAttribute('srcset'); }
      const tr = card.querySelector('[data-bae-card-track]');
      if (tr && tr.scrollLeft > 0) tr.scrollTo({ left: 0 });
      card.classList.toggle('is-model', currentView === 'model');
    });

    placeCampaigns(shown);

    const morePages = !!root.querySelector('[data-bae-more]');
    /* An empty result is only real once the whole collection is loaded. */
    const provisional = completing && visible === 0;
    /* With ALLE FITS active and pages still unloaded the rendered cards are a
       subset, so the server-rendered collection total stays the honest number. */
    const partial = currentFit === 'all' && morePages;
    const nofit = root.querySelector('[data-bae-nofit]');
    const countEl = root.querySelector('[data-bae-count]');

    if (nofit) {
      nofit.hidden = visible !== 0 || provisional;
      if (visible === 0 && !provisional) nofit.textContent = 'Geen stuks in deze pasvorm binnen deze selectie.';
    }
    if (countEl && !provisional && !partial) countEl.textContent = visible + (visible === 1 ? ' item' : ' items');
    syncAllBars();

    try {
      sessionStorage.setItem('bae:fit', currentFit);
      sessionStorage.setItem('bae:view', currentView);
    } catch (err) {}
  }

  function setView(mode) {
    currentView = mode;
    viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === mode));
    apply();
  }

  /* Delegated on the section root so the toggles survive a re-render. */
  root.addEventListener('click', (e) => {
    const fb = e.target.closest('[data-bae-fit]');
    if (fb) {
      fitButtons().forEach((x) => x.classList.remove('is-active'));
      fb.classList.add('is-active');
      currentFit = fb.dataset.baeFit;
      if (window.BaeToggle) window.BaeToggle.sync();
      apply();
      ensureFullSet();
      return;
    }
    const cb = e.target.closest('[data-bae-colour]');
    if (cb) {
      currentColour = cb.dataset.baeColour;
      colourButtons().forEach((x) => x.classList.toggle('is-active', x === cb));
      if (window.BaeToggle) window.BaeToggle.sync();
      apply();
      return;
    }
    const vb = e.target.closest('[data-bae-view]');
    if (vb) {
      setView(vb.dataset.baeView);
      if (window.BaeToggle) window.BaeToggle.sync();
    }
  });

  /* One normalization layer for fit values: anything containing 'box' → 'box',
     anything containing 'oversized' → 'oversized'. Cards emit the same values. */
  const normFit = (v) => {
    v = (v || '').toLowerCase();
    if (v === 'all' || v === '') return v || 'all';
    if (v.indexOf('box') > -1) return 'box';
    if (v.indexOf('oversized') > -1) return 'oversized';
    return v;
  };

  /* Re-paint the active state of freshly rendered controls from the state the
     visitor already chose. */
  function restoreControlState() {
    fitButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeFit === currentFit));
    viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === currentView));
    colourButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeColour === currentColour));
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  /* Colour toggle: only when the collection offers 2 or 3 colours in total
     (longsleeves: Vintage Black / Vintage White; hoodies: Black / Beige).
     Collections with many colours (tees) do not get it. Built from the
     swatches actually on the cards, so it never lists a colour nobody sells. */
  function updateColourToggle() {
    const bar = root.querySelector('.bae-coll__toggles');
    if (!bar) return;
    const names = [];
    root.querySelectorAll('[data-bae-card] [data-bae-swatch]').forEach((s) => {
      const c = s.dataset.colour;
      if (c && names.indexOf(c) < 0) names.push(c);
    });
    let grp = bar.querySelector('[data-bae-colour-group]');
    if (names.length < 2 || names.length > 3) {
      if (grp) grp.remove();
      currentColour = 'all';
      return;
    }
    if (grp && grp.dataset.sig === names.join('|')) return;
    if (grp) grp.remove();
    if (currentColour !== 'all' && names.indexOf(currentColour) < 0) currentColour = 'all';
    grp = document.createElement('div');
    grp.className = 'bae-toggle bae-toggle--tabs';
    grp.setAttribute('role', 'group');
    grp.setAttribute('aria-label', 'Kleur');
    grp.setAttribute('data-bae-colour-group', '1');
    grp.dataset.sig = names.join('|');
    const mk = (val, label) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'bae-toggle__btn' + (val === currentColour ? ' is-active' : '');
      b.setAttribute('data-bae-colour', val);
      b.textContent = label;
      return b;
    };
    grp.appendChild(mk('all', 'Alle kleuren'));
    names.forEach((n) => grp.appendChild(mk(n, n)));
    bar.appendChild(grp);
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  /* Show a control only when it offers a real choice in THIS collection:
     - fit selector needs BOTH fit families among the rendered products;
     - media selector needs at least one product with distinct model media.
     Re-evaluated after infinite scroll adds products. */
  function updateControls() {
    const cards = Array.from(root.querySelectorAll('[data-bae-card]'));
    const fits = new Set();
    cards.forEach((c) => {
      cardFitList(c).forEach((f) => fits.add(f));
    });
    const fitBtn = root.querySelector('[data-bae-fit]');
    const fitGroup = fitBtn ? fitBtn.closest('.bae-toggle') : null;
    if (fitGroup) {
      /* Keep the fit control visible while more products can still load: on a
         paginated collection the second fit family may only appear on a later
         page, so hiding purely on the current page wrongly removed the toggle.
         Only hide once the whole set is known (no more pages) AND it has <2 fits. */
      const moreToLoad = !!root.querySelector('[data-bae-more]');
      fitGroup.hidden = fits.size < 2 && !moreToLoad;
      if (fitGroup.hidden && currentFit !== 'all') {
        currentFit = 'all';
        fitButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeFit === 'all'));
      }
    }
    const hasModel = cards.some((c) => c.dataset.hasModel === '1');
    const viewBtn = root.querySelector('[data-bae-view]');
    const viewGroup = viewBtn ? viewBtn.closest('.bae-toggle') : null;
    if (viewGroup) {
      viewGroup.hidden = !hasModel;
      if (viewGroup.hidden && currentView !== 'flat') {
        currentView = 'flat';
        viewButtons().forEach((x) => x.classList.toggle('is-active', x.dataset.baeView === 'flat'));
      }
    }
    updateColourToggle();
    if (window.BaeToggle) window.BaeToggle.sync();
  }

  try {
    const savedFit = normFit(sessionStorage.getItem('bae:fit'));
    if (savedFit) {
      const b = root.querySelector('[data-bae-fit="' + savedFit + '"]');
      if (b) { fitButtons().forEach((x) => x.classList.remove('is-active')); b.classList.add('is-active'); currentFit = savedFit; }
    }
    const savedView = sessionStorage.getItem('bae:view');
    if (savedView) currentView = savedView;
  } catch (err) {}
  updateControls();
  setView(currentView);

  /* ---------- filters + sort ---------- */
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-bae-filters-open]')) {
      const f = root.querySelector('[data-bae-filters]');
      if (f) f.hidden = !f.hidden;
    } else if (e.target.closest('[data-bae-filters-close]')) {
      const f = root.querySelector('[data-bae-filters]');
      if (f) f.hidden = true;
    }
  });

  function navigate(url) {
    root.style.opacity = '.45';
    fetch(url).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-bae-collection]');
      if (fresh) root.innerHTML = fresh.innerHTML;
      window.history.replaceState({}, '', url);
      root.style.opacity = '';
      bindMore();
      updateControls();
      restoreControlState();
      apply();
      ensureFullSet();
    }).catch(() => { window.location.href = url; });
  }

  root.addEventListener('change', (e) => {
    const form = e.target.closest('[data-bae-filters]');
    if (form) {
      const params = new URLSearchParams(new FormData(form));
      const sort = root.querySelector('[data-bae-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      navigate(window.location.pathname + '?' + params.toString());
      return;
    }
    const sort = e.target.closest('[data-bae-sort]');
    if (!sort) return;
    const params = new URLSearchParams(window.location.search);
    params.set('sort_by', sort.value);
    navigate(window.location.pathname + '?' + params.toString());
  });

  /* ---------- pagination ---------- */
  let loading = false;
  let observer = null;

  /* Single append path, shared by the scroll observer and by ensureFullSet(),
     so a page is never appended twice or in two different ways.
     Resolves 'error' on a failed fetch, otherwise undefined. */
  function loadNext() {
    const sentinel = root.querySelector('[data-bae-more]');
    if (!sentinel || loading) return Promise.resolve();
    loading = true;
    return fetch(sentinel.dataset.nextUrl).then((r) => r.text()).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = doc.querySelectorAll('[data-bae-grid] > [data-bae-card]');
      const g = root.querySelector('[data-bae-grid]');
      cards.forEach((c) => g.appendChild(document.importNode(c, true)));
      const nextSentinel = doc.querySelector('[data-bae-more]');
      if (nextSentinel) sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
      else { sentinel.remove(); if (observer) observer.disconnect(); }
      loading = false;
      updateControls();
      apply();
    }).catch(() => { loading = false; return 'error'; });
  }

  function bindMore() {
    const sentinel = root.querySelector('[data-bae-more]');
    if (observer) observer.disconnect();
    if (!sentinel) return;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) loadNext(); });
    }, { rootMargin: '600px 0px' });
    observer.observe(sentinel);
  }

  /* A fit selection must be judged against the WHOLE collection. The grid is
     paginated, so a fit family can live entirely on later pages — that is what
     produced a false "0 items" state for OVERSIZED. Pull the remaining pages
     in before an empty state is allowed to show. */
  function ensureFullSet() {
    if (completing || currentFit === 'all') return;
    if (!root.querySelector('[data-bae-more]')) return;
    completing = true;
    let guard = 40;
    const step = () => {
      if (!root.querySelector('[data-bae-more]') || guard-- <= 0) { completing = false; apply(); return; }
      if (loading) { setTimeout(step, 90); return; }
      loadNext().then((res) => {
        if (res === 'error') { completing = false; apply(); return; }
        setTimeout(step, 0);
      });
    };
    apply();
    step();
  }

  bindMore();
  ensureFullSet();
})();
